import services from '@/services';

export default {
    getItem: async (entity, id, logOnly = false) => {
        id = id.replace("%", "percentage");
        return await services.getAsync(
            {
                url: `/entities/${entity}/${id}${logOnly ? '?logOnly' : ''}`,
                hasToken: entity !== 'configuration'
            });
    },
    checkInteractions: async (body) => {
        return await services.postAsync(
            {
                url: "/entities/drugs/interactions",
                body,
                hasToken: true
            }
        );
    }
}